import { Metadata } from 'src/app/core/list/metadata/metadata.component';

import { LazyLoadEvent } from 'primeng/api';

import { DefaultFilter } from './../framework/default-service.interface';
import { Lista } from './lista.model';
import { IListaBundle } from './lista-bundle.interface';
import { DomUtil } from '../framework/utils/dom-util';
import { SortDirection } from '../enums/sort-direction.enum';

export class ListaUtil {

  defineOrdenacao(event: LazyLoadEvent, _filter: DefaultFilter): DefaultFilter {
    let _order = null;
    if (event && event.sortField && event.sortOrder) {
      _order = event.sortField + ',' + (event.sortOrder === 1 ? 'asc' : 'desc');
    }
    if (_order) {
      _filter.sort = _order;
    }
    return _filter;
  }

  defineOrdenacaoPeloMetadata(metadatas: Metadata[], filter: DefaultFilter): any {
    if ( metadatas ) {
      for (const metadata of metadatas) {
        if ( metadata.sortDirection && metadata.sortDirection !== SortDirection.NONE ) {
          filter.sort = `${metadata.fieldId},${metadata.sortDirection}`;
          return filter;
        }
      }
    }
    return filter;
  }

  calculaPagina(event: LazyLoadEvent): number {
    if ( !event || event.rows === 0 ) {
      return 0;
    }
    else {
      return event.first / event.rows;
    }
  }

  criaDefaultFilter(pagina?: number): DefaultFilter {
    if ( !pagina ) {
      pagina = 0;
    }
    const filter: DefaultFilter = {
      status: 'A',
      page: pagina
    };
    return filter;
  }

  getCampoComBuscaDoMetadata(metadatas: Metadata[]): Metadata {
    if ( metadatas ) {
      for (const metadata of metadatas) {
        if ( metadata.buscaRapida ) {
          return metadata;
        }
      }
    }
    return null;
  }

  static getTarget(event: any): any {
    return DomUtil.getTarget(event);
  }

  static getCheckboxFieldId(e: IListaBundle, checkboxFieldId: string): string {
    const rowIndex = ListaUtil.getBundleRowIndex(e);
    if ( rowIndex >= 0 ) {
      const fieldId = `cb__${checkboxFieldId}_${rowIndex}`;
      const _checkbox = document.getElementById(fieldId) as HTMLInputElement;
      if ( _checkbox ) {
        return fieldId;
      }
    }

    return null;
  }

  static toggleCheckbox(e: IListaBundle, checkboxFieldId: string): void {
    const fieldId = this.getCheckboxFieldId(e, checkboxFieldId);
    if ( fieldId ) {
      // @ts-ignore
      document.getElementById(fieldId).checked = !document.getElementById(fieldId).checked;
    }
  }

  static marcarCheckbox(e: IListaBundle, checkboxFieldId: string): void {
    const fieldId = this.getCheckboxFieldId(e, checkboxFieldId);
    // @ts-ignore
    if ( fieldId && !document.getElementById(fieldId).checked ) {
      // @ts-ignore
      document.getElementById(fieldId).checked = true;
    }

  }

  static desmarcarCheckbox(e: IListaBundle, checkboxFieldId: string): void {
    const fieldId = this.getCheckboxFieldId(e, checkboxFieldId);
    // @ts-ignore
    if ( fieldId && document.getElementById(fieldId).checked ) {
      // @ts-ignore
      document.getElementById(fieldId).checked = false;
    }
  }

  static getBundleMetadata(bundle: IListaBundle): Metadata[] {
    let o: Metadata[] = null;
    try {
      if ( bundle && bundle.data ) {
        o = bundle.data['data'].columns;
      }
    }
    catch(e) {
      console.error(e.message);
    }

    return o;
  }

  static getBundleRowIndex(bundle: IListaBundle): number {
    try {
      let rowIndex: number = bundle.data.rowIndex;

      // calcular paginacao
      if ( rowIndex >= 0 ) {
        if ( bundle.data.resultset.number > 0 ) {
          rowIndex = rowIndex + ( bundle.data.resultset.number * bundle.data.resultset.size );
        }
      }

      return rowIndex;
    }
    catch(e) {
      console.error(e.message);
    }

    return null;
  }

  static getBundleResultset(bundle: IListaBundle): any {
    let o: any = null;
    try {
      if ( bundle && bundle.data ) {
        o = bundle.data['data'].resultset;
      }
    }
    catch(e) {
      console.error(e.message);
    }

    return o;
  }

  static getRows(lista: Lista) {
    return lista.resultset.content;
  }

  static incluir(item: any, lista: Lista): Lista {
    lista.resultset.content.push(item);

    return lista;
  }

  static getRowByIndex(rowIndex: number, lista: Lista): any {
    const row = lista.resultset.content[rowIndex];

    return row;
  }

}
